<div class="row calculator-row">
    <div class="col-md-4">
        <div class="grit-sand calculator-col">
            <app-grit-sand-volume-calculator></app-grit-sand-volume-calculator>
        </div>
    </div>
    <div class="col-md-4">
        <div class="bedding-mix calculator-col">
            <app-bedding-mix-calculator></app-bedding-mix-calculator>
        </div>
    </div>
 
</div>